import { IntlShape, MessageDescriptor } from 'react-intl';
import type { FormatXMLElementFn, PrimitiveType } from 'intl-messageformat';
import { TranslationKey, translationKeyToString } from 'intl/types/translationKey';
import {
  TranslatedString,
  asTranslatedString,
} from 'intl/types/translatedString';

export function formatTranslation(
  intl: IntlShape,
  key: TranslationKey,
  values?: Record<string, PrimitiveType | FormatXMLElementFn<string, string>>
): TranslatedString {
  const keyString = translationKeyToString(key);
  const descriptor: MessageDescriptor = { 
    id: keyString,
    defaultMessage: keyString // Use key as fallback to prevent errors for API-provided labels
  };
  return asTranslatedString(intl.formatMessage(descriptor, values));
}
